webpackJsonp([28011933636593,184428597545871,2786652319437],{

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactCore = __webpack_require__(3);
	
	var _SimpleGallery = __webpack_require__(213);
	
	var _SimpleGallery2 = _interopRequireDefault(_SimpleGallery);
	
	var _GalleryWithGutters = __webpack_require__(212);
	
	var _GalleryWithGutters2 = _interopRequireDefault(_GalleryWithGutters);
	
	var _getContainerProps = __webpack_require__(556);
	
	var _getContainerProps2 = _interopRequireDefault(_getContainerProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'Gallery',
	  description: 'A Gallery layout makes all of the children a uniform size, the children are displayed horizontally, and they wrap as needed.',
	  components: {
	    Gallery: _reactCore.Gallery,
	    GalleryItem: _reactCore.GalleryItem
	  },
	  examples: [{ component: _SimpleGallery2.default, title: 'Simple Gallery Layout', getContainerProps: _getContainerProps2.default }, { component: _GalleryWithGutters2.default, title: 'Gallery With Gutters', getContainerProps: _getContainerProps2.default }]
	};
	module.exports = exports['default'];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryWithGutters = function (_React$Component) {
	  _inherits(GalleryWithGutters, _React$Component);
	
	  function GalleryWithGutters() {
	    _classCallCheck(this, GalleryWithGutters);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  GalleryWithGutters.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.Gallery,
	      { gutter: 'md' },
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      )
	    );
	  };
	
	  return GalleryWithGutters;
	}(_react2.default.Component);
	
	exports.default = GalleryWithGutters;
	GalleryWithGutters.__docgenInfo = {
	  'description': '',
	  'displayName': 'GalleryWithGutters'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Gallery, GalleryItem } from '@patternfly/react-core';\n\nclass GalleryWithGutters extends React.Component {\n  render() {\n    return (\n      <Gallery gutter=\"md\">\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n      </Gallery>\n    );\n  }\n}\n\nexport default GalleryWithGutters;\n"

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies */
	
	
	var SimpleGallery = function (_React$Component) {
	  _inherits(SimpleGallery, _React$Component);
	
	  function SimpleGallery() {
	    _classCallCheck(this, SimpleGallery);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SimpleGallery.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.Gallery,
	      null,
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      ),
	      _react2.default.createElement(
	        _reactCore.GalleryItem,
	        null,
	        'Gallery Item'
	      )
	    );
	  };
	
	  return SimpleGallery;
	}(_react2.default.Component);
	
	exports.default = SimpleGallery;
	SimpleGallery.__docgenInfo = {
	  'description': '',
	  'displayName': 'SimpleGallery'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

	module.exports = "/* eslint-disable import/no-extraneous-dependencies */\nimport React from 'react';\nimport { Gallery, GalleryItem } from '@patternfly/react-core';\n\nclass SimpleGallery extends React.Component {\n  render() {\n    return (\n      <Gallery>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n        <GalleryItem>Gallery Item</GalleryItem>\n      </Gallery>\n    );\n  }\n}\n\nexport default SimpleGallery;\n"

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactStyles = __webpack_require__(5);
	
	var _reactTokens = __webpack_require__(16);
	
	var styles = _reactStyles.StyleSheet.create({
	  demoLayout: {
	    '& .pf-l-gallery > div': {
	      height: 100,
	      borderWidth: _reactTokens.global_BorderWidth_md.var,
	      borderStyle: 'dashed',
	      borderColor: _reactTokens.global_BorderColor.var
	    }
	  }
	});
	
	exports.default = function () {
	  return { className: (0, _reactStyles.css)(styles.demoLayout) };
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.gallery_package = exports.gallery_docs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GalleryDocs = __webpack_require__(555);
	
	var _GalleryDocs2 = _interopRequireDefault(_GalleryDocs);
	
	var _componentDocs = __webpack_require__(15);
	
	var _componentDocs2 = _interopRequireDefault(_componentDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rawExamples = [{ name: 'GalleryWithGutters', path: '../../react-core/src/layouts/Gallery/examples/GalleryWithGutters.js', file: __webpack_require__(457) }, { name: 'SimpleGallery', path: '../../react-core/src/layouts/Gallery/examples/SimpleGallery.js', file: __webpack_require__(458) }];
	var images = [{ name: 'img_avatar.svg', file: __webpack_require__(7) }, { name: 'l_pf-reverse-164x11.png', file: __webpack_require__(8) }, { name: 'pf_logo.svg', file: __webpack_require__(9) }, { name: 'pf_mini_logo_white.svg', file: __webpack_require__(10) }, { name: 'img_avatar.svg', file: __webpack_require__(12) }, { name: 'pf_logo.svg', file: __webpack_require__(13) }, { name: 'pf_logo_color.svg', file: __webpack_require__(14) }, { name: 'pfbg_992.jpg', file: __webpack_require__(11) }];
	
	var gallery_docs = exports.gallery_docs = _GalleryDocs2.default;
	var gallery_package = exports.gallery_package = 'react-core';
	
	exports.default = function () {
	    return _react2.default.createElement(_componentDocs2.default, _extends({ rawExamples: rawExamples, images: images }, _GalleryDocs2.default));
	};

/***/ })

});


// WEBPACK FOOTER //
// component---tmp-gallery-docs-js-f7c3f5c9d231cdaf7384.js